import createReducer from 'redux/utils/createReducer';
import { HYDRATE } from 'next-redux-wrapper';
import types from './types';

// Set initial state
export const initialState = {
   user: {},
   authentication: {},
   appointments: [],
   bookingPageURL: '',
};

const userReducer = createReducer(initialState, {

    [types.SET_USER](state, action) {
        if (!action.user) return state;
        return {
            ...state,
            user: {...action.user},
        };
    },

    [types.SET_AUTHENTICATION](state, action) {
        if (!action.authentication) return state;
        return {
            ...state,
            authentication: {...action.authentication},
        };
    },

    [types.SET_APPOINTMENTS](state, action) {
        if (!action.appointments) return state;
        return {
            ...state,
            appointments: [...action.appointments],
        };
    },

    [types.SET_BOOKING_PAGE_URL](state, action) {
        if (!action.bookingPageURL) return state;
        return {
            ...state,
            bookingPageURL: action.bookingPageURL,
        };
    },

    [HYDRATE]: (state, { payload }) => ({
        ...state,
        ...payload.user,
    }),
});

export default userReducer;
